<template>
  <footer class="app-footer">
    <span>🎂 повод: Алла</span>
    <span>собрали ночью · работает как работает</span>
  </footer>
</template>

<style scoped>
.app-footer {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  padding: 1rem 1.25rem;
  border-top: 1px solid #fce7f3;
  color: #be185d;
  background: rgba(255, 255, 255, 0.85);
  font-size: 0.92rem;
}
</style>
